import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20film%20studio%20scene%20with%20warm%20dramatic%20lighting%2C%20movie%20camera%20and%20director%20chair%20on%20set%2C%20golden%20hour%20backlight%20through%20windows%2C%20professional%20film%20production%20atmosphere%2C%20elegant%20golden%20and%20crimson%20color%20palette%2C%20rich%20textures%20and%20soft%20shadows%2C%20clean%20background%20with%20warm%20tones&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
        alt="麻豆传媒影视制作场景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
            <i className="ri-film-line text-sm text-accent-400"></i>
            <span className="text-xs text-white/90 font-medium">正版授权 · 高清品质</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            探索优质影视内容
            <br />
            <span className="text-accent-400">体验极致视听娱乐</span>
          </h1>

          <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            麻豆传媒专注优质影视内容制作与发行，汇集海量正版高清影视资源，
            涵盖悬疑、情感、奇幻、动作等多元类型，为您打造专属的沉浸式观影体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              浏览全部作品
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/#membership"
              className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              了解会员权益
              <i className="ri-vip-crown-line ml-2"></i>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-14">
            {[
              { value: '500+', label: '正版影片' },
              { value: '2000万+', label: '注册用户' },
              { value: '98%', label: '好评率' },
              { value: '30+', label: '合作片方' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-white/40"></i>
      </div>
    </section>
  );
}